import React, { useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { toast } from 'react-toastify';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';
import { DynamicLinksModal } from './DynamicLinksModal';
import { EventsModal } from './EventsModal';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-css';

export const CustomComponentEditor = ({
  title,
  icon,
  value,
  onChange,
  onSubmit,
  mode,
  collectionName,
  collections,
  projectDetail,
  pages,
  events,
  showDynamicOptions = false,
}) => {
  const [isOpenFieldsModal, setIsOpenFieldsModal] = useState(false);
  const [isOpenLinksModal, setIsOpenLinksModal] = useState(false);
  const [isOpenEventsModal, setIsOpenEventsModal] = useState(false);
  const [editor, setEditor] = useState(null);

  const [fullScreen, setFullscreen] = useState(false);
  const handleFullScreen = () => {
    setFullscreen((prevState) => !prevState);
  };

  const copyToClipboard = (toastMsg) => {
    setIsOpenFieldsModal(false);
    setIsOpenLinksModal(false);
    setIsOpenEventsModal(false);
    toast.success(toastMsg);
  };

  const insertTextToParamInput = (textToInsert, toastMsg) => {
    if (textToInsert && editor) {
      const cursorPosition = editor.getCursorPosition();
      editor.session.insert(cursorPosition, textToInsert);
      copyToClipboard(toastMsg);
    }
  };

  const showAddFieldsModal = () => {
    const collection =
      collections && collections.length
        ? collections.find((coll) => coll.collectionName === collectionName)
        : {};
    return (
      <RestAPICollectionFieldsModal
        selectedCollection={collection}
        collections={collections}
        copyToClipboard={() => copyToClipboard('Copied to clipboard')}
        insertTextToEditor={(textToInsert) => insertTextToParamInput(textToInsert, 'Text Inserted')}
        toggleFields={isOpenFieldsModal}
        toggleFieldsModal={() => setIsOpenFieldsModal(!isOpenFieldsModal)}
        projectDetail={projectDetail}
        hide={['tenantFields', 'userSettingFields']}
      />
    );
  };

  const showDynamicLinksModal = () => {
    return (
      <DynamicLinksModal
        isOpen={isOpenLinksModal}
        pages={pages}
        collections={collections}
        parentCollection={collectionName}
        toggle={() => setIsOpenLinksModal(!isOpenLinksModal)}
        insertTextToParamInput={insertTextToParamInput}
        copyToClipboard={copyToClipboard}
      />
    );
  };

  const showEventsModal = () => {
    return (
      <EventsModal
        events={events}
        isOpen={isOpenEventsModal}
        insertTextToParamInput={insertTextToParamInput}
        handleToggle={() => setIsOpenEventsModal(!isOpenEventsModal)}
      />
    );
  };

  return (
    <>
      {showAddFieldsModal()}
      {showDynamicLinksModal()}
      {showEventsModal()}
      <ParentCardNoCol
        title={title}
        icon={icon}
        bgColor="drapcode-violet"
        CtaComponent={
          showDynamicOptions ? (
            <>
              <button
                type="button"
                style={{ background: 'transparent', border: 'none' }}
                onClick={handleFullScreen}
                title="Toggle Fullscreen"
              >
                <i
                  className={`btn btn-outline-primary btn-xs btn-icon-only ${drapcodeIcon(
                    'fullscreen',
                  )}`}
                ></i>
              </button>
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title="Add Dynamic Fields"
                onClick={() => setIsOpenFieldsModal(true)}
              >
                <i className="wb webconnect-plus" /> Add Dynamic Fields
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title="Add Dynamic Links"
                onClick={() => setIsOpenLinksModal(true)}
              >
                <i className="wb webconnect-plus" /> Add Dynamic Links
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title="Add Events"
                onClick={() => setIsOpenEventsModal(true)}
              >
                <i className="wb webconnect-plus" /> Add Events
              </button>
            </>
          ) : (
            ''
          )
        }
      >
        <div className="cssEditorui">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12">
              <AceEditor
                mode={mode}
                theme="tomorrow"
                value={value}
                name="code-editor1"
                width="100%"
                height={fullScreen ? '75vh' : '60vh'}
                fontSize={15}
                wrapEnabled={true}
                showPrintMargin={false}
                onChange={onChange}
                onLoad={(editor) => setEditor(editor)}
              />
            </div>
          </div>
          <div className="d-flex flex-row-reverse">
            <button className="btn btn-theme-submit btn-md" title="Update" onClick={onSubmit}>
              <i className="wb webconnect-save-regular"></i> Update
            </button>
          </div>
        </div>
      </ParentCardNoCol>
    </>
  );
};
